import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createReducer = () => {
    const initialState = {
        filter: {
            allSelected: true,
            statusIds: [],
            statusTypes: [],
        }
    }

    return handleActions({
        [ActionTypes.STATUS_FILTER_SET]: (state, {payload: filter}) => ({
            ...state,
            filter
        }),
    }, initialState)
}

export default createReducer


// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/reducer.js